// extracted by mini-css-extract-plugin
export default {"navbarContainer":"Menu_navbarContainer__jZ5Zo","navLink":"Menu_navLink__u6-Sb"};